/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Descargar Bumble",
      "Aceptarlas todas",
      "Gestionar opciones",
      "Política de cookies",
      "Volver",
      "Número de teléfono incorrecto",
      "@{{current_year}}Bumble  | Todos los derechos reservados",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Sobre",
      "Embajadores",
      "Blog",
      "Este sitio web utiliza cookies. Al navegar por el sitio web sin modificar los ajustes, aceptas el uso de cookies por nuestra parte.",
      "Descargar la aplicación",
      "Descargar para Android",
      "Descargar para iOS",
      "Lo sentimos, pero no hemos podido encontrar la página que estabas buscando.",
      "Entrar",
      "Únete",
      "¡Únete!",
      "Vaya, se ha producido un error"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
